<template>
    <div>
        <div style="width:100%;" class="el-table el-table--fit el-table--border">
            <div class="el-table__body-wrapper">
                <el-form :model="vo">
                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                    <tbody>
                        <tr>
                            <td ref="tdlbl_教师编号" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'employeeNo'" class="field">教师编号</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'employeeNo'" class="field">{{ vo.employeeNo }}</span>
                            </td>
                            <td ref="tdlbl_入职日期" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'entryDate'" class="field">入职日期</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'entryDate'" class="field">{{ formatDate(vo.entryDate) }}</span>
                            </td>
                            <td ref="tdlbl_转正日期" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'conversionDate'" class="field">转正日期</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'conversionDate'" class="field">{{ formatDate(vo.conversionDate) }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_所属单位" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'orgName'" class="field">所属单位</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'orgName'" class="field">{{ vo.orgName }}</span>
                            </td>
                            <td ref="tdlbl_工作方式" class="el-table__cell tdlbl tdw13" colspan="1">

                                <span v-field-lbl="'workNature'" class="field">工作方式</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'workNature'" class="field">{{ vo.workNature==1?'外派':'借调' }}</span>
                            </td>
                            <td ref="tdlbl_借调/外派日期" class="el-table__cell tdlbl tdw13" colspan="1">

                                <span v-field-lbl="'secondmentDate'" class="field">借调/外派日期</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'secondmentDate'" class="field">{{ formatDate(vo.secondmentDate) }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_部门" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'department'" class="field">部门</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'department'" class="field">{{ employmentInfo.department }}</span>
                            </td>
                            <td ref="tdlbl_职位类型" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'postType'" class="field">职位类型</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'postType'" class="field">{{ formatPostType(employmentInfo.postType) }}</span>
                            </td>
                            <td ref="tdlbl_职位" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'post'" class="field">职位</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'post'" class="field">{{ employmentInfo.post }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_职级" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'postRank'" class="field">职级</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'postRank'" class="field">{{ employmentInfo.postRank }}</span>
                            </td>
                            <td ref="tdlbl_排序编号" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'sortNumber'" class="field">排序编号</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'sortNumber'" class="field">{{ employmentInfo.sortNumber }}</span>
                            </td>
                            <td ref="tdlbl_编制部门" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'preparationDepart'" class="field">编制部门</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <span v-field-lbl="'preparationDepart'" class="field">{{ employmentInfo.preparationDepart==0?'是':'否' }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    props: {
        vo: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            employmentInfo: {}, //职位信息
            appointmentInfo: {} //任职信息
        }
    },
    computed: {},
    watch: {},
    created: function() {
        this.$http({
            method: 'post',
            url: '/xsgl/rsglArchiveAppointmnetInfo/listdata?urlsearch=userId:' + this.loginUser.userId
        }).then(res => {
            if (res.code == 'success') {
                let _id = res.body.pageInfo.list[0].id
                this.$http({
                    method: 'get',
                    url: '/xsgl/rsglArchiveAppointmnetInfo/getById?id=' + _id
                }).then(res => {
                    if (res.code == 'success') {
                        this.employmentInfo = res.body.vo
                    }
                })
            }
        })
    },
    mounted: function() {
    },
    methods: {
        formatDate(val) {
            if (val) {
                return moment(val).format('YYYY-MM-DD')
            } else {
                return ''
            }
        },
        formatPostType(val) {
            if (val == 1) {
                return '主负责人'
            } if (val == 2) {
                return '副负责人'
            } if (val == 3) {
                return '普通员工'
            }
        }
    }
}
</script>

<style scoped>
    .header {
        padding: 10px 20px;
        background-color: #f2f5fb;
        font-size: 14px;
        font-weight: 500;
    }
</style>
